import { render, staticRenderFns } from "./LessonAssigmentContent.vue?vue&type=template&id=7939c890&scoped=true&"
import script from "./LessonAssigmentContent.vue?vue&type=script&lang=ts&"
export * from "./LessonAssigmentContent.vue?vue&type=script&lang=ts&"
import style0 from "./LessonAssigmentContent.vue?vue&type=style&index=0&id=7939c890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7939c890",
  null
  
)

export default component.exports